// extracted by mini-css-extract-plugin
export default {"title":"TradingHistory_title","description":"TradingHistory_description","loader":"TradingHistory_loader"};